// src/pages/NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-tb-bg dark:bg-tb-night text-tb-ink dark:text-tb-d-text px-6">
      <div className="text-center">
        <p className="font-mono text-sm text-tb-muted">404</p>
        <h1 className="mt-2 text-2xl font-display font-bold">Page not found</h1>
        <Link to="/" className="mt-4 inline-block text-sm font-medium text-tb-brand hover:underline">
          Back to portal
        </Link>
      </div>
    </div>
  );
}
